<template>
  <div>
    <iframe v-if="!loading" v-resize="{ log: false }"  frameborder="0" class="embed-web" :src="'/docs/docs'" />
  </div>
</template>

<script>
import CloudfrontCookieService from "../../../../services/cloudfront-cookie.service";
import iframeResize from 'iframe-resizer/js/iframeResizer';

export default {
  mounted: async function () {
    await CloudfrontCookieService.refreshCookies();
    this.loading = false;
  },
  data: () => ({
    loading: true,
  }),
  directives: {
    resize: {
      bind: function(el, { value = {} }) {
        el.addEventListener('load', () =>{
          iframeResize(value, el)
          }
        )
      },
      unbind: function (el) {
        el.iFrameResizer.removeListeners();
      }
    }
  }
};
</script>

<style scoped>
.embed-web {
  width: 1px;
  min-width: 100%;
}
</style>